export const commonDateTimeFormat = 'yyyy/MM/dd HH:mm:SS';